/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    TEAM_MEMBER_ADD_SUCCESS,
    TEAM_MEMBER_LIST_SUCCESS
} from "../../../types";

/**
 * @param {*} state
 * @param {*} action
 */
const TeamMemberReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    let teamId = action.payload.id;
    if (teamId === undefined || teamId === null) return state;
    if (state[teamId] === undefined) state[teamId] = {};

    switch (action.type) {
        case TEAM_MEMBER_LIST_SUCCESS:
            let teams = action.payload.data.data;

            teams.map((team) => {
                let id = team['id'];
                state[teamId][id] = team;
                return true;
            });

            return {...state, action};

        case TEAM_MEMBER_ADD_SUCCESS:
            let id = action.payload.data['id'];
            state[teamId][id] = action.payload.data;
            return {...state, action};
        default:
            return state;
    }
};

export {TeamMemberReducer}